var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"wrapper tab-how",attrs:{"id":"onboarding-de","role":"form","method":"post"},on:{"submit":function($event){$event.preventDefault();}}},[_c('learnt-about-vitadio-form',{on:{"clicked":function($event){return _vm.nextTab()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }